export default __webpack_public_path__ + "static/media/greece.0785e771.webp";